<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>

    <!-- Modal Component -->
    
    <b-row>
      <b-col sm="12">
        <div>
          <b-card :title="procedeOrden ? 'Antes de continuar, llene y verifique los siguientes datos:' : ''"
                  tag="article"
                  class="mb-2">
            <b-row>

              <b-col sm="12" md="12" lg="6">
                <b-card>
                  
                  <b-card-body>
                    <div>
                      <label for="input-live">Orden:</label>
                      <b-form-input
                        id="input-live"
                        v-model="orden"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese orden"
                        trim
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Referencia:</label>
                      <b-form-input
                        id="input-live"
                        v-model="referencia"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese referencia"
                        trim
                      ></b-form-input>
                    </div>
                    <!-- <div>
                      <label for="input-live">Concepto:</label>
                      <b-form-input
                        id="input-live"
                        v-model="concepto"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese concepto"
                        trim
                      ></b-form-input>
                    </div> -->
                    <div>
                      <label for="input-live">Importe:</label>
                      <b-form-input
                        id="input-live"
                        v-model="importe"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese importe"
                        trim
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Nombre:</label>
                      <b-form-input
                        id="input-live"
                        v-model="nombre"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese nombre"
                        trim
                      ></b-form-input>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>

               <b-col sm="12" md="12" lg="6">
                <b-card>
                  <b-card-body>
                    <h6><b-badge variant="primary"><i class="fa fa-check"></i></b-badge>
                    2. Página segura:
                    </h6>
                    <br>
                    <b-img src="/img/https.png" center/>
                  </b-card-body>
                  <b-card-body>
                    <h6><b-badge variant="primary"><i class="fa fa-check"></i></b-badge>
                    3. Página correcta:
                    </h6>
                    <br>
                    <h4 class="text-center">https://pagos.elsalto.gob.mx</h4>
                  </b-card-body>
                  <b-card-body>
                      <b-form-checkbox id="checkbox1"
                            v-model="verificado"
                            value="accepted"
                            unchecked-value="not_accepted">
                        He verificado que todos los datos son correctos
                        </b-form-checkbox>
                  </b-card-body>
                  <b-card-body>
                      <b-button variant="success" @click="realizarPago()">Pagar</b-button>
                      <b-button variant="secondary" class="pull-right" @click="cancelar()">Cancelar</b-button>
                  </b-card-body>
                </b-card>

              </b-col>

            </b-row>
          </b-card>

            <!-- <form action="https://prepro.adquiracloud.mx/clb/endpoint/municipioDeElSalto/" ref="pagar" method="POST" target="_self"> -->
              <!-- <input type="hidden" name="mp_account" value="7923"> -->
            <form action="https://www.adquiramexico.com.mx/clb/endpoint/municipioDeElSalto" ref="pagar" method="POST" target="_self">
              <input type="hidden" name="mp_account" value="8614">
              <input type="hidden" name="mp_product" value="1">
              <input type="hidden" name="mp_order" ref="orden" value="">
              <input type="hidden" name="mp_reference" ref="referencia" value="">
              <input type="hidden" name="mp_node" value="0">
              <input type="hidden" name="mp_concept" ref="concepto" value="1">
              <input type="hidden" name="mp_amount" ref="importe" value="">
              <input type="hidden" name="mp_customername" ref="nombre" value="">
              <input type="hidden" name="mp_currency" value="1">
              <input type="hidden" name="mp_signature" ref="firma" value="">
              <input type="hidden" name="mp_urlsuccess" ref="success" value="">
              <input type="hidden" name="mp_urlfailure" ref="failure" value="">
            </form>

        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axios from "axios";
import { mapGetters } from "vuex";
import Loader from './Loader'

const numeral = require('numeral');

export default {
  name: 'RealizarPago',
  components: {
    Loader
  },
  computed:{
    ...mapGetters([
      "httpURL"
    ]),
    correoValido(){ 
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.correo).toLowerCase());
    },
    datosValidados(){
        if(this.verificado == 'not_accepted' || !this.correoValido)
            return false;
        else 
            return true;
    },
    procedeOrden(){
      if( !this.ordenPrevia )
        return true;
      else{
        if( this.ordenPrevia.status === 3 || this.ordenPrevia.status === 4 || this.ordenPrevia.status === 5 )
          return false;
        else  
          return true;
      }
    }
  },
  data: function () {
    return {
      enviando: false,
      verificado: 'not_accepted',
      orden: null,
      referencia: null,
      concepto: null,
      importe: null,
      nombre: null,
    }
  },
  methods: {
    moneda(cantidad){
        return numeral(cantidad).format('$0,0.00');
    },
    realizarPago(){

        this.enviando = true;
        axios.post(this.httpURL+'/operacion/firma',
            {orden: this.orden, referencia: this.referencia, importe: this.importe})
            .then(res => {
                console.log(res.data);
                //console.log(res.data);
                this.$refs.orden.value = this.orden;
                this.$refs.referencia.value = this.referencia;
                // this.$refs.concepto.value = division;
                this.$refs.importe.value = this.importe;
                this.$refs.nombre.value = this.nombre;
                this.$refs.firma.value = res.data.firma;
                
                this.$refs.success.value = 'https://elsalto.gob.mx/pago-resultado';
                this.$refs.failure.value = 'https://elsalto.gob.mx/pago-resultado';
        
                this.$refs.pagar.submit();
                //this.enviando = false;
            })
            .catch(error => {
                console.log(error);
                this.enviando = false;
                this.tokenValido = false;
            });

    },
    cancelar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
